module.exports = __webpack_public_path__ + "media/images/icons/outlined/rotate-left-6a06d7a8e4f8dba7cebc25cfc4699df2.svg";